import React, {Component,} from 'react';
import {Alert} from "reactstrap";
import {connect} from "react-redux";
import {setLastHistory, setShowPumbaDescription} from "../../actions/commonInfo";

class PumbaMaintenance extends Component {

    componentDidMount() {
        // check if the user navigated to another tab
        if(this.props.lastHistory && this.props.lastHistory !== this.props.history.location.pathname){
            this.props.setShowPumbaDescription(false)
        }else{
            this.props.setLastHistory(this.props.history.location.pathname)
        }
    }

    render() {
        return <Alert color="danger" style={{marginBottom: 0, paddingBottom: 0}}
                      isOpen={this.props.showPumbaDescription} toggle={() => {
            this.props.setShowPumbaDescription(false)
        }}>
            <p>
                <strong>System maintenance notice: </strong>
                Please be informed that on <strong>Tuesday 31st October between 8am and 5pm</strong> we will be having a system maintenance and you might experience some downtime.
                Thank you for understanding.
            </p>
        </Alert>
    }
}

const mapStateToProps = (state) => {
    const props = {
        showPumbaDescription: state.commonInfo.showPumbaDescription,
        lastHistory: state.commonInfo.lastHistory
    }
    return props
}

const mapDispatchToProps = (dispatch) => {
    return {
        setShowPumbaDescription: (showPumbaDescription) => {
            dispatch(setShowPumbaDescription(showPumbaDescription))
        },
        setLastHistory: (lastHistory) => {
            dispatch(setLastHistory(lastHistory))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PumbaMaintenance)


// WEBPACK FOOTER //
// ./src/components/common/PumbaMaintenance.js